// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconHelpCircle: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 12 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12">
            <path
                fill="currentcolor"
                d="M10.875 6A4.871 4.871 0 0 0 6 1.125 4.871 4.871 0 0 0 1.125 6 4.871 4.871 0 0 0 6 10.875 4.871 4.871 0 0 0 10.875 6ZM0 6c0-3.305 2.695-6 6-6s6 2.695 6 6-2.695 6-6 6-6-2.695-6-6Zm6-1.875a.74.74 0 0 0-.75.75.57.57 0 0 1-.563.563.57.57 0 0 1-.562-.563A1.88 1.88 0 0 1 6 3a1.88 1.88 0 0 1 1.875 1.875c0 1.102-.844 1.57-1.313 1.758v.07A.555.555 0 0 1 6 7.266a.555.555 0 0 1-.563-.563v-.187c0-.47.352-.82.704-.938a.937.937 0 0 0 .421-.234c.118-.094.188-.235.188-.469a.74.74 0 0 0-.75-.75Zm-.75 4.5a.74.74 0 0 1 .75-.75.74.74 0 0 1 .75.75.74.74 0 0 1-.75.75.74.74 0 0 1-.75-.75Z"
            />
        </svg>
    );
};

export default React.memo(IconHelpCircle);
